












































import commons from "@/common/store/modules/commons";
import { Prop, Vue, Component, Model } from "vue-property-decorator";
import { mapState } from "vuex";

@Component
export default class InputRadio extends Vue {
  @Model("input", { type: Boolean }) readonly checked!: boolean;

  @Prop({ type: String, required: true })
  name!: string;
  // @Prop({}) checked!: any;
  @Prop({}) value!: any;
  @Prop({ type: String, required: false, default: "main" }) kind!: string;
  @Prop({ type: String, required: false }) error!: string;
  @Prop({ type: Boolean, default: false }) disabled!: boolean;

  get colorCode() {
    return commons?.colorCode;
  }

  updateValue(e: any) {
    this.$emit("input", this.value);
    this.$emit("checked", this.value);
  }
}
